import React, { useState } from 'react';
import { View, Text, TextInput, Pressable } from 'react-native';

import { setMultipleOptionSelection } from '../services/CommonUtils';

import { PrimaryCTA } from '../widgets/CommonCTA';
import { CloseIcon, HorizontalDivider } from '../widgets/Common-Widget';

import Modal from 'react-native-modal';
import Checkbox from 'expo-checkbox';
import AppStyles from '../../AppStyles';
import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';

const MultipleOptionSelectionBottomSheet = (props) => {
    const showModal = props.showModal
    const modalTitle = props.modalTitle
    const optionsList = props.optionsList
    const closeModal = props.closeModal
    const primaryAction = props.primaryAction
    const ctaTitle = props?.ctaTitle ?? 'Submit'

    const [selectedOption, updateSelectedOption] = useState({
        selectedIndexList: [],
        selectedOptions: [],
        toggleViewIndex: -1,
        exclusiveIndex: -1
    })

    const [otherCancelDescp, updateDescriptionText] = useState('')

    function checkOptionSelected(index) {
        var indexList: any = selectedOption.selectedIndexList;
        return indexList.includes(index);
    }

    function checkCancelCTAEnable() {
        if (selectedOption?.selectedIndexList?.length) {
            if (selectedOption.toggleViewIndex == -1 || otherCancelDescp)
                return true
            else return false
        } else return false
    }

    function getSelectedOptionsValue(selectedOptions) {
        let optionsValue = []
        selectedOptions.map((option, index) => {
            optionsValue.push(option['value'])
        })
        return optionsValue
    }

    return <Modal backdropOpacity={0.70}
        deviceWidth={window.innerWidth}
        deviceHeight={window.innerHeight}
        animationOutTiming={1000}
        animationOut={'slideOutDown'}
        isVisible={showModal}
        style={[{ justifyContent: 'flex-end', margin: 'auto', width: AppTheme.appWidth }]}
        onBackdropPress={() => closeModal()}>
        <View style={{
            backgroundColor: 'white', padding: 16,
            borderTopRightRadius: 12, borderTopLeftRadius: 12
        }}>

            <View style={[AppStyles.flexRowSpaceBetween]}>
                <Text style={[TextStyle.text20b]}>
                    {modalTitle}</Text>
                <CloseIcon onPress={() => closeModal()} />
            </View>

            <View style={{ marginTop: 12, marginBottom: 20 }}>
                {optionsList.map((option, index) =>
                    <View key={index}>
                        <View style={{ marginVertical: 16 }}>
                            <Pressable key={index} onPress={() => {
                                setMultipleOptionSelection(option, index, {
                                    selectedOption: selectedOption,
                                    updateSelectedOption: updateSelectedOption,
                                    updateDescription: updateDescriptionText
                                })
                            }} style={[AppStyles.flexRowStart]}>
                                <Checkbox style={{ marginRight: 8 }}
                                    value={checkOptionSelected(index)}
                                    color={checkOptionSelected(index) ?
                                        AppTheme.color.primary : undefined} />
                                <Text style={[TextStyle.text14xb]}> {option['dispStr']}</Text>
                            </Pressable>
                        </View>

                        {selectedOption['toggleViewIndex'] == index ? <TextInput numberOfLines={1}
                            multiline={true} style={[
                                TextStyle.text14b, {
                                    borderWidth: 1, borderColor: AppTheme.color.primary, color: AppTheme.color.grey.text,
                                    borderRadius: 8, paddingHorizontal: 16, paddingVertical: 10
                                }]}
                            onChangeText={(text) => { updateDescriptionText(text) }}
                            placeholder="If you have any other reason, write here..."
                            value={otherCancelDescp} /> : null}

                        {index == optionsList.length - 1 ?
                            null : <HorizontalDivider width={AppTheme.appWidth - 32} />}

                    </View>)
                }
            </View>

            <PrimaryCTA text={ctaTitle} action={() => {
                closeModal();
                primaryAction(getSelectedOptionsValue(selectedOption.selectedOptions),
                    otherCancelDescp)
            }} disabled={!checkCancelCTAEnable()} />

        </View>
    </Modal>
}

export default MultipleOptionSelectionBottomSheet